import { Observable } from 'rxjs';
import { PlanesConTarifas, TarifaBaseParams } from '../../interfaces/tarifa/tarifa.interface';

export abstract class TarifaRepository {
  abstract consultarTarifasPlanes(params: TarifaBaseParams): Observable<PlanesConTarifas>;
}
